import {
  hardCodeIsCaesarStone,
  hardCodeIsLowes,
  hardCodeIsMcDermott,
  hardCodeIsModerno,
  hardCodeIsPorcelanosa,
  isProd
} from "../../misc/fabricatorHardcode";

export const isDevMode = () => {
  return window.location.href.includes("dev=1") || document.kvConfig.devMode
};

export const SQFT_POST_MESSAGE_ACTIONS = {
  initialLoad: "initialLoad",
  setQTData: "setQTData",
  closeSqFtCalc: "closeSqFtCalc",
  callResetDataPopup: "callResetDataPopup",
  callChangeLayoutDataPopup: "callChangeLayoutDataPopup",
  userIdleResetCounter: "userIdleResetCounter",
  resetHistory: "resetHistory",
  saveHistory: "saveHistory",
  setNewLayoutOnSqft: "setNewLayoutOnSqft",
  setCanvasCenter: "setCanvasCenter",
  stopRender: "stopRender",
  startRender: "startRender",
};

export const MEASURE_UNITS = {
  Metric: "Metric",
  Imperial: "Imperial",
};

/**
 *
 * This is used only to take shape part id
 * @type {{top_cabinet: string, bottom_cabinet: string, center_island_countertop: string, slabPlaceHolder: string, seamPiece: string, countertop: string, spacer: string, vanity_countertop: string, backsplashPiece: string}}
 */
export const SHAPE_PART_ID = {
  edge: 'edge',
  seamPiece: 'seamPiece',
  backsplashPiece: 'backsplashPiece',
  waterfallPiece: 'waterfallPiece',
  slabPlaceHolder: 'slabPlaceHolder',
  top_cabinet: 'top_cabinet',//
  wall_vanity_cabinet: 'wall_vanity_cabinet',
  bottom_cabinet: 'bottom_cabinet',//
  tall_cabinet: 'tall_cabinet', //
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  vanity_cabinet: 'vanity_cabinet',
  linen_vanity_cabinet: 'linen_vanity_cabinet',
  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
  vanity_boxes: 'vanity_boxes',
  top_cabinet_boxes: 'top_cabinet_boxes',
  wall_cabinet_boxes: 'wall_cabinet_boxes',
  linen_cabinet_boxes: 'linen_cabinet_boxes',
  linen_vanity_boxes: 'linen_vanity_boxes',
  countertop: 'countertop',
  spacer: 'spacer',
  vanity_countertop: 'vanity_countertop',
  center_island_countertop: 'center_island_countertop',
  center_island_cabinet: 'center_island_cabinet',
  front_wall: 'front_wall',

  //appliances
  dishwasher: "dishwasher",
  range: "range",
  hood: "hood",
  fridge: "fridge",
  stove: "stove",
};

export const SQFT_FEATURES = {
  bumpouts: 'bumpouts',
  countertop: 'countertop',
  center_island_countertop: 'center_island_countertop',
  vanity_countertop: 'vanity_countertop',
  oversized: 'oversized',
  slabs: 'slabs',
  backsplash: 'backsplash',
  backsplashes: 'backsplashes',
  vanity_backsplash: 'vanity_backsplash',
  edge: 'edge',
  edge_profile: 'edge_profile',
  center_island_edge: 'center_island_edge',
  radius: 'radius',
  corners: 'corners',
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  vanity_accent: 'vanity_accent',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
  top_cabinet: 'top_cabinet',
  wall_vanity_cabinet: 'wall_vanity_cabinet',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  top_handle: 'top_handle',
  bottom_cabinet: 'bottom_cabinet',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  bottom_handle: 'bottom_handle',
  tall_cabinet: 'tall_cabinet',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  vanity_cabinet: 'vanity_cabinet',
  linen_vanity_cabinet: 'linen_vanity_cabinet',
  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
  vanity_boxes: 'vanity_boxes',
  top_cabinet_boxes: 'top_cabinet_boxes',
  wall_cabinet_boxes: 'wall_cabinet_boxes',
  linen_cabinet_boxes: 'linen_cabinet_boxes',
  linen_vanity_boxes: 'linen_vanity_boxes',
  crown_molding: 'crown_molding',
  handle: 'handle',
  underlayment: 'underlayment',
  wall_door_end_accessory: 'wall_door_end_accessory',
  base_door: 'base_door',
  island_panel: 'island_panel',
  refridgerator_panel: 'refridgerator_panel',
  end_cap: 'end_cap',
  hinge: 'hinge',
};

export const APPLIANCE_PART_IDS = [
  SHAPE_PART_ID.dishwasher,
  SHAPE_PART_ID.hood,
  SHAPE_PART_ID.fridge,
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.range
]

export const APPLIANCE_UPPER_PART_IDS = [
  SHAPE_PART_ID.hood,
]

export const APPLIANCE_LOWER_PART_IDS = [
  SHAPE_PART_ID.dishwasher,
  SHAPE_PART_ID.fridge,
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.range
]

export const FEATUREGROUP_PART_ID = {
  specialty_cut_and_designs: 'specialty_cut_and_designs'
}

export const SHAPE_ROTATE_DIRECTION = {
  right: 0,
  left: 1,
};

export const ALIGN = {
  right: 'right',
  left: 'left',
  center: 'center',
};

export const SHAPE_TYPE = {
  polygon: "polygon",
  square: "square",
  wideangle: "wideangle",
  horseshoe: "horseshoe",
  appliances: "appliances",
};

export const RENDER_TEMPLATES = {
  default: "default",
  disabled: "disabled",
  linesOnly: "linesOnly",
  filledPrimary: "filledPrimary",
  accordingToFeature: "accordingToFeature",
  filledActive: "filledActive",
  filledRed: "filledRed",
};

/**
 * NAVIGATION
 */
export const SIDEBAR2_BUTTONS = [
  {
    menu: "summary",
    classNames: "button--parent button--summary",
    text: "mobile.summary",
    hasMenu: true
  },
  // {
  //   menu: "settings",
  //   classNames: "button--parent button--settings",
  //   text: "settings",
  //   hasMenu: true
  // }
];

export const SIDEBAR_BUTTONS_MENU = {
  move: "move",
  shapes: "shapes",
  layouts: "layouts",
  summary: "summary",
  delete: "delete",
  cabinetset: "cabinetset"
}

export const SIDEBAR_SLAB_BUTTONS = {
  move: "move",
  //moveSlab: "moveSlab",
  rotate: "rotate",
  loadSlab: "loadSlab",
  seam: "seam",
  duplicate: "duplicate",
  delete: "delete",
};

export const MOVABLE_IMAGE_TYPES = {
  slabImage: "slabImage",
};

export const SIDEBAR_SLAB_SEAM_BUTTONS = {
  addFreeSeam: "addFreeSeam", //todo enable when ready
  addSeamHorizontal: "addSeamHorizontal",
  addSeamVertical: "addSeamVertical",
  undoSeam: "undoSeam",
  resetSeams: "resetSeams",
};

/**
 * remember to update SIDEBAR_HIDDEN_BUTTONS (names should be the same)
 */
export const SIDEBAR_NAVIGATION_BUTTONS = {
  move: "move",
  //freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  radius: "radius",
  edge: "edge",
  backsplash: "backsplash",
  end_cap: "end_cap",
  appliances: "appliances",
  //angle: "angle",
  bumpout: "bumpout",
  label: "label",
  text: "text",
  ...((!hardCodeIsLowes()) && { mitered: "mitered" }),
  ...((!hardCodeIsMcDermott() && !hardCodeIsLowes()) && { toolWaterfall: "toolWaterfall" }),
  ...((!isProd && (hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode())) && { toolUnderlayment: "toolUnderlayment" }),
  duplicate: "duplicate",
};

export const SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS = {
  move: "move",
  freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  edge: "edge",
  bumpout: "bumpout",
  mitered: "mitered",
  ...((hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode()) && {toolWaterfall: "toolWaterfall"}),
  appliances: "appliances",
  label: "label",
  text: "text",
  duplicate: "duplicate",
};

export const SIDEBAR_NAVIGATION_CABINET_BUTTONS = {
  move: "move",
  resize: "resize",
  rotate: "rotate",
  lower: "lower",
  upper: "upper",
  tall: "tall",
  centerIsland: "centerIsland",
  spacer: "spacer",
  //style: "style",
  wall: "wall",
  crown_molding: "crown_molding",
  handles: "handles",
  hinge: "hinge",
  // top_handle: "top_handle",
  // bottom_handle: "bottom_handle",
  end_panel: "end_panel",
  appliances: "appliances", // disable appliances for caes
  text: "text",
};

export const SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS = {
  move: "move",
  resize: "resize",
  rotate: "rotate",
  vanity: "vanity",
  top_cabinet_boxes: "top_cabinet_boxes",
  wall_cabinet_boxes: "wall_cabinet_boxes",
  linen_cabinet_boxes: "linen_cabinet_boxes",
  spacer: "spacer",
  wall: "wall",
  appliances: "appliances",
  text: "text",
};

export const SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS = {
  //move: "move",
  top_cabinet: "top_cabinet",
  bottom_cabinet: "bottom_cabinet",
  tall_cabinet: "tall_cabinet",
  upper_cabinet_boxes: "upper_cabinet_boxes",
  lower_cabinet_boxes: "lower_cabinet_boxes",
  tall_cabinet_boxes: "tall_cabinet_boxes",
  //crown_molding: "crown_molding",
  handles: "handles",
  centerIsland: "centerIsland",
  //vanity: "vanity",
  //spacer: "spacer",
  //wall: "wall",
  //appliances: "appliances",
  //text: "text",
};

export const SIDEBAR_NAVIGATION_3D_BATHROOM_CABINET_BUTTONS = {
  //move: "move",
  vanity_cabinet: "vanity_cabinet",
  vanity_cabinet_boxes: "vanity_cabinet_boxes",
  linen_vanity_cabinet: "linen_vanity_cabinet",
  linen_cabinet_boxes: "linen_cabinet_boxes",
  top_cabinet_boxes: "top_cabinet_boxes",
  wall_vanity_cabinet: "wall_vanity_cabinet",
  wall_cabinet_boxes: "wall_cabinet_boxes",
  vanity_countertop: "vanity_countertop",
  //vanity: "vanity",
  //spacer: "spacer",
  //wall: "wall",
  //appliances: "appliances",
  //text: "text",
};

export const SIDEBAR_SHAPE_BUTTONS = {
  square: "square",
  lshape: "lshape",
  wideangle: "wideangle",
  rectangle: "rectangle",
  dot: "dot",
  freeDraw: "freeDraw",
  shapeFreeForm: "shapeFreeForm",
};

export const SIDEBAR_NAVIGATION_BUTTONS_LEVEL3 = {
  filters: "filters",
};

export const FREE_FORM_THICKNESS_POPUP_ID = "freeForm";

export const SIDEBAR_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.tools",
    shouldHardcodeMessage: true,
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true,
    subMenu: SIDEBAR_SHAPE_BUTTONS
  }, {
    menu: "layouts",
    message: "sqft.navigation.menu.layouts",
    hasMenu: true
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_TYPE_AREA_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true,
    subMenu: SIDEBAR_SHAPE_BUTTONS
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
];

export const SIDEBAR_CABINET_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_CABINET_BUTTONS
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },...(isDevMode() ? [{
    menu: "cabinetset",
    message: "Cabinet Set",
  }] : []),
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_3D_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_CABINET_BUTTONS
  }, ...(!isProd() ? [{
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  }] : []), ...(isDevMode() ? [{
    menu: "cabinetset",
    message: "Cabinet Set",
  }] : []),
];

export const SIDEBAR_WITH_FEATURES_SUBMENU = [
  SIDEBAR_NAVIGATION_BUTTONS.end_cap,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
  SQFT_FEATURES.top_cabinet,
  SQFT_FEATURES.bottom_cabinet,
  SQFT_FEATURES.tall_cabinet,
  SQFT_FEATURES.vanity_cabinet,
  SQFT_FEATURES.wall_vanity_cabinet,
  SQFT_FEATURES.linen_vanity_cabinet,
  SQFT_FEATURES.vanity_countertop,
];

export const RIGHT_SIDEBAR_WITH_FEATURES_SUBMENU = [
  SIDEBAR_NAVIGATION_BUTTONS.end_cap,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
];

export const SIDEBAR_HIDDEN_BUTTONS = {
  mitered: "mitered",
  toolWaterfall: "toolWaterfall",
  toolUnderlayment: "toolUnderlayment",
  buttonMitered: "buttonMitered",
  buttonCustomBacksplash: "buttonCustomBacksplash",
  buttonBacksplashFreeDraw: "buttonBacksplashFreeDraw",
  edgePeninsulaUnderwrap: "edgePeninsulaUnderwrap",
};

/*
* Hide shapes after removing them in popup window
*/
export const isDisabledInPopupShouldBeHidden = () => {
  return hardCodeIsCaesarStone() //enabled only for caesarstone
}

export const SIDEBAR_LAYOUTS_BUTTONS = [
  "S", "SP", "SI", "SPI", "SN", "SPN", "SNI", "SPNI", "L", "LI", "LN", "LNI"
];

export const SQFT_APPLIANCES = {
  cabinetPlaceholder: "cabinetPlaceholder",
  hood: "hood",
  refrigerator: "refrigerator",
  range: "range",
  sink: "sink",
  doubleSink: "doubleSink",
  dishwasher: "dishwasher",
  iceMachine: "ice machine",
  oven: "oven",
  stovetop: "stovetop",
  trashCompactor: "trash compactor",
  wineFridge: "wine fridge"
};

export const SQFT_APPLIANCES_BATHROOM = {
  tub: "tub",
  toilet: "toilet",
  vanity: "vanity",
  wet_space: "wet space"
};

export const SQFT_APPLIANCES_CAES = {
  hood: "hood",
  sink: "sink",
  stovetop: "stovetop",
};

export const SQFT_APPLIANCES_ON_TOP_SHAPES = [
  SQFT_APPLIANCES.sink,
  SQFT_APPLIANCES.doubleSink
];

export const CABINET_LABELS = {
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
  tall_cabinet: 'tall_cabinet',
  crown_molding: 'crown_molding',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  handle: 'handle',
};

export const CABINET_BATHROOM_LABELS = {
  vanity_cabinet: 'vanity_cabinet',
  linen_vanity_cabinet: 'linen_vanity_cabinet',

  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
  top_cabinet_boxes: 'top_cabinet_boxes',
  linen_cabinet_boxes: 'linen_cabinet_boxes',
  linen_vanity_boxes: 'linen_vanity_boxes',
  vanity_size: 'vanity_size',
  vanity_boxes: 'vanity_boxes',
  wall_vanity_cabinet: 'wall_vanity_cabinet',
  wall_cabinet_boxes: 'wall_cabinet_boxes',
};

export const CABINET_BOXES = [
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.vanitie_cabinet_boxes,
  SHAPE_PART_ID.vanity_cabinet_boxes,
  SHAPE_PART_ID.vanity_boxes,
  SHAPE_PART_ID.top_cabinet_boxes,
  SHAPE_PART_ID.wall_cabinet_boxes,
  SHAPE_PART_ID.linen_cabinet_boxes,
  SHAPE_PART_ID.linen_vanity_boxes,
];

export const KITCHEN_CABINET_BOX_PART_IDS = [
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
];

export const BATHROOM_CABINET_BOX_PART_IDS = [
  SHAPE_PART_ID.vanity_cabinet_boxes,
  SHAPE_PART_ID.vanitie_cabinet_boxes,
  SHAPE_PART_ID.vanity_boxes,
  SHAPE_PART_ID.top_cabinet_boxes,
  SHAPE_PART_ID.wall_cabinet_boxes,
  SHAPE_PART_ID.linen_cabinet_boxes,
  SHAPE_PART_ID.linen_vanity_boxes,
];

// Cabinet box groups whose 3D models are mounted in the upper wall lane.
export const WALL_MOUNTED_CABINET_BOX_PART_IDS = [
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.top_cabinet_boxes,
  SHAPE_PART_ID.wall_cabinet_boxes,
];

export const WALL_MOUNTED_CABINET_PARENT_PART_IDS = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.wall_vanity_cabinet,
];

export const WALL_MOUNTED_CABINET_PART_IDS = [
  ...WALL_MOUNTED_CABINET_BOX_PART_IDS,
  ...WALL_MOUNTED_CABINET_PARENT_PART_IDS,
];

export const SQFT_CABINET_APPLIANCES = {
  //hood: "hood",
  //microwave: "microwave",
};

export const SQFT_APPLIANCES_WITH_SUBMENU = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  SQFT_APPLIANCES.range,
  SQFT_CABINET_APPLIANCES.microwave,
  //partIds which names are mismatched
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.fridge,
]

export const SQFT_PART_IDS_WITH_NAV_ITEMS_FROM_FEATURE_GROUP = [
  ...SQFT_APPLIANCES_WITH_SUBMENU,
  SQFT_FEATURES.top_cabinet,
  SQFT_FEATURES.bottom_cabinet,
  SQFT_FEATURES.tall_cabinet,
  SQFT_FEATURES.vanity_cabinet,
  SQFT_FEATURES.wall_vanity_cabinet,
  SQFT_FEATURES.linen_vanity_cabinet,
  SQFT_FEATURES.vanity_cabinet_boxes,
  SQFT_FEATURES.vanitie_cabinet_boxes,
  SQFT_FEATURES.vanity_boxes,
  SQFT_FEATURES.top_cabinet_boxes,
  SQFT_FEATURES.wall_cabinet_boxes,
  SQFT_FEATURES.linen_cabinet_boxes,
  SQFT_FEATURES.linen_vanity_boxes,
  SQFT_FEATURES.radius,
  SQFT_FEATURES.corners,
]

// Buttons for these part IDs should never be removed from the UI even when no features are found.
// They can still be disabled (by wizard or missing nav items), but not fully hidden.
export const SQFT_BUTTONS_PART_IDS_NEVER_REMOVE = [
  SQFT_FEATURES.radius,
  SQFT_FEATURES.corners,
  // SQFT_FEATURES.top_cabinet_boxes,
  // SQFT_FEATURES.linen_cabinet_boxes,
  // SQFT_FEATURES.linen_vanity_boxes,
  // SQFT_FEATURES.vanity_cabinet,
]

export const SQFT_SHAPES_THAT_ADD_OVERHANG = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.range,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  CABINET_LABELS.tall_cabinet_boxes,
  //CABINET_LABELS.lower_cabinet_boxes,
  //partIds which names are mismatched
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.fridge,
]

export const SQFT_MODE = {
  regular: "regular",
  slab: "slab",
};

export const SQFT_VIEW_MODE = {
  twoDMode: "2d Mode",
  threeDMode: "3d Mode",
  threeDModeDoors: "3d Mode Doors",
  threeDModeFramed: "Framed",
  threeDModeFrameless: "Frameless",
  augmentedReality: "Augmented Reality",
  augmentedRealityCabinet: "Augmented Reality Cabinet",
  augmentedRealityDoorsOnly: "Augmented Reality Doors Only"
}

export const SQFT_VIEW_3D_MODES = [
  SQFT_VIEW_MODE.threeDMode,
  SQFT_VIEW_MODE.threeDModeDoors,
  SQFT_VIEW_MODE.threeDModeFramed,
  SQFT_VIEW_MODE.threeDModeFrameless,
];

export const SQFT_VIEW_AR_MODES = [
  SQFT_VIEW_MODE.augmentedReality,
  SQFT_VIEW_MODE.augmentedRealityCabinet,
  SQFT_VIEW_MODE.augmentedRealityDoorsOnly,
]

export const MANUAL_CALCULATION_ROW_TYPES = {
  countertopRows: "countertopRows",
  backsplashRows: "backsplashRows",
  edgeRows: "edgeRows",
};

export const DIRECTION = {
  north: "north",
  east: "east",
  south: "south",
  west: "west",
};

export const MANUAL_CALCULATION_MEASURE = {
  length: "length",
  height: "height",
  width: "width",
  selectedFeature: "selectedFeature",
};

export const SQFT_BACKSPLASH_TYPES = ["4", "6", "18"];
export const SQFT_BACKSPLASH_TYPES_METRIC = ["100", "150", "600"];
export const SQFT_WALL_TYPES = ["wall"];
export const SQFT_MEASURE_UNIT = {
  imperial: "Imperial",
  metric: "Metric",
};
export const FREE_DRAW_TYPE = {
  shape: "shape",
  shapeFreeForm: "shapeFreeForm",
  wall: "wall",
  backsplash: "backsplash",
};

export const CONTEXT_MENU_TYPE = {
  list: "list",
  buttons: "buttons",
};

export const DEFAULT_EXPORTED_SQFT_FEATURES = [
  SQFT_FEATURES.crown_molding,
  SQFT_FEATURES.radius,
  SQFT_FEATURES.corners,
  SQFT_FEATURES.underlayment,
  SQFT_FEATURES.bumpouts,
]

export const PARENT_KEYS_WITH_COMBINED_FEATURES_IN_CART = [
  'edges',
  'edge',
  'edge_profile',
  'center_island_edge',
  'backsplash',
  'backsplashes',
  'countertop',
  'center_island_countertop',
  'radius',
  'corners',
  'slabs',
  'vanity_countertop',
  'vanity_backsplash',
  'shower_wall',
  'shower_interior_wall',
  'shower_interior_wall_accent',
  'accent_wall',
  'shower_floor',
  'bathroom_floor',
  'kitchen_floor',
  'wall_a',
  'wall_b',
  'wall_c',
  'front_wall',
];

export const END_CAP_CABINETS_PART_IDS = [
  SQFT_FEATURES.wall_door_end_accessory,
  SQFT_FEATURES.base_door,
  SQFT_FEATURES.island_panel,
  SQFT_FEATURES.refridgerator_panel,
];

export const END_CAP_AREA_PART_IDS = [
  SQFT_FEATURES.end_cap,
];

export const END_CAP_PART_IDS = [
  ...END_CAP_CABINETS_PART_IDS,
  ...END_CAP_AREA_PART_IDS,
];

export const SQFT_PARENT_FEATURE_GROUP_PART_IDS = {
  upper_cabinet_boxes: 'top_cabinet',
  tall_cabinet_boxes: 'tall_cabinet',
  lower_cabinet_boxes: 'bottom_cabinet',
  vanity_cabinet_boxes: 'vanity_cabinet',
  vanitie_cabinet_boxes: 'vanity_cabinet',
  vanity_boxes: 'vanity_cabinet',
  top_cabinet_boxes: 'top_cabinet',
  wall_cabinet_boxes: 'wall_vanity_cabinet',
  linen_cabinet_boxes: 'linen_vanity_cabinet',
  linen_vanity_boxes: 'linen_vanity_cabinet',
}

export const SQFT_CHILD_FEATURE_GROUP_PART_IDS = {
  top_cabinet: 'upper_cabinet_boxes',
  tall_cabinet: 'tall_cabinet_boxes',
  bottom_cabinet: 'lower_cabinet_boxes',
}

export const SQFT_CABINET_CHILD_FEATURE_GROUP_PART_IDS = {
  top_cabinet: 'upper_cabinet_boxes',
  tall_cabinet: 'tall_cabinet_boxes',
  bottom_cabinet: 'lower_cabinet_boxes',
}

export const SQFT_AREA_TYPE_PART_IDS = {
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
};

export const COUNTERTOP_LABELS = {
  center_island_countertop: 'center_island_countertop',
  countertop: 'countertop',
  vanity_countertop: 'vanity_countertop',
  vanity_accent: 'vanity_accent',
  shower_wall: 'shower_wall',
  shower_wall_accent: 'shower_wall_accent',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  accent_wall: 'accent_wall',
  shower_floor: 'shower_floor',
  bathroom_floor: 'bathroom_floor',
  kitchen_floor: 'kitchen_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
};

export const CABINET_PART_IDS_THAT_CAN_HAVE_HANDLES = [
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
]

export const HANDLE_TO_CABINETS = {
  [SQFT_FEATURES.top_handle]: [SQFT_FEATURES.upper_cabinet_boxes],
  [SQFT_FEATURES.bottom_handle]: [SQFT_FEATURES.lower_cabinet_boxes, SQFT_FEATURES.tall_cabinet_boxes],
  [SQFT_FEATURES.handle]: [SQFT_FEATURES.upper_cabinet_boxes, SQFT_FEATURES.lower_cabinet_boxes],
};

export const CABINETS_TO_HANDLE = {
  [SQFT_FEATURES.upper_cabinet_boxes]: SQFT_FEATURES.top_handle,
  [SQFT_FEATURES.lower_cabinet_boxes]: SQFT_FEATURES.bottom_handle,
  [SQFT_FEATURES.tall_cabinet_boxes]: SQFT_FEATURES.bottom_handle,
};

export const CABINET_PART_IDS_WITH_HALF_PRICE = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
]

export const CABINET_PART_IDS = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
]

export const CABINET_BATHROOM_PART_IDS = [
  SHAPE_PART_ID.vanity_cabinet,
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.wall_vanity_cabinet,
  SHAPE_PART_ID.linen_vanity_cabinet,
]

export const CABINET_COMMON_COLOR_PART_IDS = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
  SHAPE_PART_ID.vanity_cabinet,
  SHAPE_PART_ID.wall_vanity_cabinet,
  SHAPE_PART_ID.linen_vanity_cabinet,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.vanity_cabinet_boxes,
  SHAPE_PART_ID.vanitie_cabinet_boxes,
  SHAPE_PART_ID.vanity_boxes,
  SHAPE_PART_ID.top_cabinet_boxes,
  SHAPE_PART_ID.wall_cabinet_boxes,
  SHAPE_PART_ID.linen_cabinet_boxes,
  SHAPE_PART_ID.linen_vanity_boxes,
];

export const FEATURE_QUANTITY_UNITS = [
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.vanitie_cabinet_boxes,
  SHAPE_PART_ID.vanity_cabinet_boxes,
  SHAPE_PART_ID.vanity_boxes,
  SHAPE_PART_ID.top_cabinet_boxes,
  SHAPE_PART_ID.wall_cabinet_boxes,
  SHAPE_PART_ID.linen_cabinet_boxes,
  SHAPE_PART_ID.linen_vanity_boxes,
];

//this part ids used to remove buttons if there are no features
export const HIDE_MENU_WITH_NO_FEATURES = [
  SHAPE_PART_ID.tall_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.top_cabinet,
  SQFT_FEATURES.handle,
  SQFT_FEATURES.top_handle,
  SQFT_FEATURES.bottom_handle,
  ...END_CAP_CABINETS_PART_IDS,
  SQFT_FEATURES.bottom_handle,
  SQFT_FEATURES.countertop,
  SQFT_FEATURES.vanity_countertop,
  SQFT_FEATURES.hinge,
  SQFT_FEATURES.crown_molding
];

export const BACKSPLASH_LABELS = {
  backsplash: 'backsplash',
  backsplashes: 'backsplashes',
  vanity_backsplash: 'vanity_backsplash',
};

export const EDGE_LABELS = {
  edge: 'edge',
  edge_profile: 'edge_profile',
  center_island_edge: 'center_island_edge',
};

export const CORNER_LABELS = {
  radius: 'radius',
  corner: 'corner',
};

export const HANDLE_LABELS = [
  SQFT_FEATURES.top_handle,
  SQFT_FEATURES.bottom_handle,
  SQFT_FEATURES.handle,
];

export const HINGE_LABELS = [
  SQFT_FEATURES.hinge,
];

export const SHOULD_DISPLAY_FEATURES_ONLY_WITH_AR3DUrls = [
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
  SQFT_FEATURES.vanity_cabinet_boxes,
  SQFT_FEATURES.vanitie_cabinet_boxes,
  SQFT_FEATURES.vanity_boxes,
  SQFT_FEATURES.upper_cabinet_boxes,
  SQFT_FEATURES.lower_cabinet_boxes,
  SQFT_FEATURES.tall_cabinet_boxes,
  SQFT_FEATURES.top_cabinet_boxes,
  SQFT_FEATURES.wall_cabinet_boxes,
  SQFT_FEATURES.linen_cabinet_boxes,
  SQFT_FEATURES.linen_vanity_boxes,
  SQFT_FEATURES.vanity_countertop,
  ...SQFT_APPLIANCES_WITH_SUBMENU,
];

// export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = [
//   SQFT_FEATURES.backsplashes,
//   SQFT_FEATURES.countertop,
//   SQFT_FEATURES.center_island_countertop,
//   SQFT_FEATURES.shower_wall,
//   SQFT_FEATURES.shower_floor,
//   SQFT_FEATURES.kitchen_floor,
//   SQFT_FEATURES.vanity_countertop,
//   SQFT_FEATURES.vanity_backsplash,
//   SQFT_FEATURES.shower_interior_wall,
//   SQFT_FEATURES.shower_interior_wall_accent,
//   SQFT_FEATURES.bathroom_floor,
//   SQFT_FEATURES.wall_a,
//   SQFT_FEATURES.wall_b,
//   SQFT_FEATURES.wall_c
// ];

export const SHAPE_PART_IDS_USING_SAME_COLOR = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  waterfallPiece: SHAPE_PART_ID.waterfallPiece,
  backsplashPiece: SHAPE_PART_ID.backsplashPiece,
  seamPiece: SHAPE_PART_ID.seamPiece,
}

export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
}

export const ALLOWED_LABEL_NAV_ITEMS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  ...CABINET_LABELS,
  ...CABINET_BATHROOM_LABELS,
  ...SQFT_AREA_TYPE_PART_IDS,
  ...END_CAP_PART_IDS
}

export const POINT_PROPERTY = {
  angle: 'angle',         // 45 degCorner
  arcLength: 'arcLength', // Radius
}

export const POINT_PROPERTY_PART_ID = {
  [POINT_PROPERTY.angle]: 'corners',
  [POINT_PROPERTY.arcLength]: 'radius',
}

export const RESOURCE_TYPE = {
  attachedToLine: 'attachedToLine',
  waterfallSectionsData: 'waterfallSectionsData',
  underlaymentSections: 'underlaymentSections',
  selectedFeature: null
}

export const RESOURCE_ATTACHED_TO_TYPE = {
  edge: 'edge',
  backsplash: 'backsplash',
  wall: 'wall',
  mitered: 'mitered',
  underlayment: 'underlayment',
  bumpout: 'bumpout',
  waterfall: 'waterfall',
  crown_molding: 'crown_molding',
  end_cap: 'end_cap',
}

export const RESOURCE_ATTACHED_TO_NAME = {
  waterfall: 'Waterfall',
}

export const WORKSPACE_RESOURCES = {
  spacers: 'spacers',
  handles: 'handles',
  hinge: 'hinge',
  crownMolding: 'crownMolding',
  walls: 'walls',
  shapeColors: 'shapeColors',
  waterfall: 'waterfall',
  removedFeatures: 'removedFeatures',
  snappedShapeGroups: 'snappedShapeGroups',
  selectedShapes: 'selectedShapes',
  images3d: 'images3d',
  images3dAutoSaved: 'images3dAutoSaved',
}

/**
 * Should be unique
 * @type {{peninsulaUnderwrap: string, underlayment: string, waterfall: string, cabinetReturn: string, overhangReturn: string}}
 */
export const WATERFALL_SHAPES_KEY = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Ppeninsula Underwrap',
}

export const WATERFALL_SHAPES_NAME = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Underlayment',
}

export const SQFT_GROUP_DROPDOWN = {
  cabinets: 'cabinets',
  countertop: 'countertop',
}

export const SQFT_GROUP = {
  area: 'area',
  cabinets: 'cabinets',
  default: 'default',
}

export const SQFT_AR3D_POPUP_CONTENT_TYPE = {
  ar: 'ar',
  threeD: 'threeD',
}

export const SQFT_AR3D_GLB_VIEWER = {
  singleModel: 'singleModel',
  separateModels: 'separateModels',
}

export const MITER_UNDERWRAP_EDGE_NAMES = [
  "miter underwrap"
];

/**
 * Additional material ( miter edge height is taken from edge name (except Rimrock - 981))
 * @type {string[]}
 */
export const MITER_EDGE_NAMES = [
  'miter 1 1/2"',
  'miter 2"-3"',
  'miter 4"-6"',
  'miter edge',
  'mitered edge',
  'rimrock - 981',
  'ingletado',
  'inglete',
  'inglete.',
  'edge build-up',
  '2cm mitered',
  '3cm mitered',
  '4cm mitered',
  '5cm mitered',
  'mitered apron',
  'miter',
]

export const WATERFALL_EDGE_NAMES = [
  'simple waterfall',
  'waterfall',
]

export const WATERFALL_OVERLAY_TYPE = {
  waterfall: 'waterfall',
  peninsulaUnderwrap: 'peninsulaUnderwrap',
}

export const MITERED_OVERLAY_TYPE = {
  mitered: "mitered",
  underlayment: "underlayment",
}

export const APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE = [
  SQFT_APPLIANCES.sink,
  SQFT_APPLIANCES.doubleSink,
  SQFT_APPLIANCES.stovetop
]

export const CABINET_FILTER_NAMES = {
  knobs: 'Number_of_Knobs',
  hinges: 'Number_of_Hinges',
  slideSets: 'Numbe_of_Slide_Sets',
  doors: 'Number_of_Doors',
  drawers: 'Number_of_Drawers',
}

export const FEATURE_PICKER_TYPE = {
  handles: 'HANDLES_CHANGE',
  hinges: 'HINGE_CHANGE',
  shape: 'SHAPE_CHANGE',
}

export const PART_IDS_THAT_CAN_BE_CHANGED_IN_SQFT = [
  ...Object.keys(EDGE_LABELS),
  //...Object.keys(BACKSPLASH_LABELS),
  SQFT_FEATURES.crown_molding,
  SIDEBAR_NAVIGATION_BUTTONS.radius,
]

export const ALLOWED_STYLE_COLOR = {
  "diamond": [
    "ADOBE rPET","ALOE SUPERMATTE","BAJA rPET","BISQUE","FASHIONISTA","FREE SPIRIT",
    "HAZE SUPERMATTE","LOVE AT FIRST SIGHT","MIDNIGHT SUPERMATTE","MIST SUPERMATTE",
    "NIZZA","NORDIC WHITE SUPERMATTE","OASIS rPET","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "ROJA rPET","RUSTIC LIGHT OAK","SAGE SUPERMATTE","SHEER BEAUTY",
    "SILT SUPERMATTE (Stone Grey)","SNOW WHITE (White Lacquer)","STRATUS SUPERMATTE",
    "WHITE SMARTMATTE","WINTER FUN","BLACK SMARTMATTE"
  ],
  "7500": [
    "ADOBE rPET","ALOE SUPERMATTE","BAJA rPET","BISQUE","FASHIONISTA","FREE SPIRIT",
    "HAZE SUPERMATTE","LOVE AT FIRST SIGHT","MIDNIGHT SUPERMATTE","MIST SUPERMATTE",
    "NIZZA","NORDIC WHITE SUPERMATTE","OASIS rPET","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "ROJA rPET","RUSTIC LIGHT OAK","SAGE SUPERMATTE","SHEER BEAUTY",
    "SILT SUPERMATTE (Stone Grey)","SNOW WHITE (White Lacquer)","STRATUS SUPERMATTE",
    "WHITE SMARTMATTE","WINTER FUN","BLACK SMARTMATTE"
  ],
  "10900": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE"
  ],
  "shaker shallow": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE",
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "shaker slim": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE",
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "900": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE",
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "aspen": [
    "ADOBE rPET","BAJA rPET","OASIS rPET","ROJA rPET","NORDIC WHITE SUPERMATTE",
    "FASHIONISTA","FREE SPIRIT","PALOMINO","PELEE ISLAND PEAR","ROGUE VALLEY PEAR",
    "LOVE AT FIRST SIGHT","SHEER BEAUTY","BLACK SMARTMATTE",
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "tm403 csoo": [
    "LOVE AT FIRST SIGHT","MIST SUPERMATTE","NORDIC WHITE SUPERMATTE","PALOMINO",
    "PELEE ISLAND PEAR","ROGUE VALLEY PEAR","HAZE SUPERMATTE","NIZZA",
    "SNOW WHITE (White Lacquer)","WINTER FUN"
  ],
  "tm405": ["FASHIONISTA"],
  "tm504 skoo": [
    "MIST SUPERMATTE","NORDIC WHITE SUPERMATTE","PALOMINO","NIZZA",
    "SNOW WHITE (White Lacquer)","WINTER FUN"
  ],
  "tm506": ["FASHIONISTA","FREE SPIRIT"],
  "tm404": ["POLAR WHITE"],

  "london 10900": [
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "london 900": [
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ],
  "london 10500": [
    "snow white","white lacquer","stratus supermatte","morning dew supermatte",
    "white smartmatte","rustic light oak","sage supermatte","nizza","bisque",
    "winter fun","aloe supermatte","midnight supermatte","haze supermatte","silt supermatte"
  ]
};


export const FEATURES_WITH_DISABLED_RESIZING = ['SW-BES12L Base Cabinet', 'SW-BES12R Base Cabinet'];

export const CABINET_SET5_KITCHEN_MAGIK = {
}
